import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errorText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useDash } from "../../lib/dash";
import { TileState } from "./Tile";
import { AlertsTile } from "./AlertsTile";
import { AlertStatusTile } from "./AlertStatusTile";
import { AlertRulesTile } from "./AlertRulesTile";

// Tile 9: open alerts + the backup row (left), email + provider balances and the rules (right). Owner-only edits.
export const AlertsTab = () => {
  const s = useDash("/dash/alerts");
  const { user } = useAuth();
  const [saved, setSaved] = useState(null);
  useEffect(() => setSaved(null), [s.data]);
  const save = useCallback(async (body) => {
    try {
      const { data } = await api.put("/dash/alerts/settings", body);
      setSaved(data);
      toast.success("Alert setting saved");
    } catch (e) {
      toast.error(errorText(e, "Could not save the alert setting."));
    }
  }, []);
  const d = saved || s.data;
  const owner = user?.role === "owner";
  return (
    <TileState state={s}>
      {d && (
        <div data-testid="dash-alerts" className="grid gap-3 lg:h-full lg:grid-cols-12 lg:grid-rows-2">
          <div className="min-h-0 lg:col-span-7 lg:row-span-2"><AlertsTile d={d} index={0} /></div>
          <div className="min-h-0 lg:col-span-5"><AlertStatusTile d={d} owner={owner} onSave={save} index={1} /></div>
          <div className="min-h-0 lg:col-span-5"><AlertRulesTile rules={d.rules} owner={owner} onSave={save} index={2} /></div>
        </div>
      )}
    </TileState>
  );
};
